export enum AdvisoryModel {
    A = 'A',
    C = 'C',
    G = 'G',
    P = 'P',
}
